import React from 'react';
import styled from 'styled-components';

import { ThreeSectionSliderBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { Carousel, useCarouselState } from 'components/Carousel';
import { RichTextHeadline } from 'components/Text';
import { colors } from 'theme';

import { ThreeSectionSliderBlockCarouselNavigation } from './ThreeSectionSliderBlockCarouselNavigation';
import { ThreeSectionSliderBlockSection } from './ThreeSectionSliderBlockSection';
import { THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES } from './threeSectionSliderConstants';

const CarouselContainer = styled.div`
  position: relative;
  margin-top: 40px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 100%;
    width: 2px;
    background: white;
  }
`;

type Props = {
  data: ThreeSectionSliderBlockData;
};

export function ThreeSectionSliderBlock({ data }: Props) {
  const { headline, imageSize, sections } = data;

  const withImages = sections.some((section) => section.image);

  const carouselState = useCarouselState({
    slideCount: sections.length,
    responsiveSlidesPerPage: { xs: 1, sm: 1, md: 2, lg: 3 },
  });

  return (
    <>
      {headline && (
        <RichTextHeadline textAlign="center">{headline}</RichTextHeadline>
      )}

      <CarouselContainer>
        <Carousel
          state={carouselState}
          data-qa-id="three-section-slider-carousel"
          height={THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES[imageSize] + 26}
          navigation={
            <ThreeSectionSliderBlockCarouselNavigation
              carouselState={carouselState}
            />
          }
          slides={sections.map((section, index) => (
            <Box height="100%">
              <ThreeSectionSliderBlockSection
                imageQaId="slider-image"
                text={section.content}
                image={section.image}
                imageSize={imageSize}
                withImages={withImages}
                borderLeft={[
                  null,
                  null,
                  index > 0 ? `1px solid ${colors.silver}` : null,
                ]}
              />
            </Box>
          ))}
        />
      </CarouselContainer>
    </>
  );
}
